// flow weak
import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Alert,
  Checkbox,
  Modal,
  Table,
  Form
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "./dashboard.scss";
import {
  getDealList,
  currentDealList,
  dealDetail,
  addToCart,
  generateCoupon,
  CheckUserKey
} from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";
import noImg from "../../../img/no_img.jpg";
import "react-responsive-tabs/styles.css";
import noRecordFound from "../../../img/no-record-found.png";
import ReactHtmlParser from "react-html-parser";

import { geolocated } from "react-geolocated";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";

import { Notification } from "../../../components/notifications";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';
import moment from "moment";
import Cookies from "universal-cookie";
import Reviews from "./Reviews.js";
import ReviewList from "./ReviewList.js";
import Question from "./Question.js";
import languageConfig from "../../../config/languageConfig";
import UseDfpSlot from "./UseDfpSlot";
import ScriptSlot from "./ScriptSlot";
const cookies = new Cookies();
const history = createBrowserHistory();
let rand = require("random-key");
let isLoading = "false", limit = 24;
let now = moment();
function Currency(props) {
  const cur = props.default_currency == 'EUR' ? '€' : '$';
  return (
    <span
      className={props.className}
    >
      {props.default_lang == 'en' ? cur : ''}
      {props.amount}
      {props.default_lang == 'fr' ? cur : ''}
      {(props.moretext != '' && props.moretext != undefined) ? ' - ' : ''}
      {props.moretext != '' ? props.moretext : ''}
    </span>
  );
}
class AuctionDetail extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList: "",
      currentDeals: [],
      show: false,
      alertMessage: "",
      limit: 24,
      perPage: 24,
      total: "",
      dealID: [],
      topDealHighlights: "",
      modelShow: false,
      quantity: '',
      placeBidAmount: '',
      proposalType: 'Auctions',
      recipientEmail: '',
      recipientName: '',
      personalMessage: '',
      wdith: 0,
      height: 0,
      notifications: '',
      hover: false,
      default_city: '',
      multi_lang: 'no',
      lang: '',
      default_lang: "(cookies.get('default_lang') ? cookies.get('default_lang') : 'en')",
      load_more: 'no',
      isChecked: false,
      currency: '',
      symbol: '',
      NoRecord: '',
      topDeal: [],
      ClickToSelect: 0,
      attribute: [],
      errorattribute: [],
      activeTab: 1,
      fontFamilies: '',
      notUnique: false,
      disabled : false
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.checkoutAttribute = this.checkoutAttribute.bind(this);
    this.pagination = this.pagination.bind(this);
    this.handleAttributes = this.handleAttributes.bind(this);
    this.addToCartAttribute = this.addToCartAttribute.bind(this);
    this.ShowAttribute = this.ShowAttribute.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitAsGift = this.submitAsGift.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  getValidUrl = (url = "") => {
    let newUrl = window.decodeURIComponent(url);
    newUrl = newUrl.trim().replace(/\s/g, "");

    if (/^(:\/\/)/.test(newUrl)) {
      return `http${newUrl}`;
    }
    if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
      return `http://${newUrl}`;
    }

    return newUrl;
  }

  stripTags = (str) => {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();

    return str.replace(/(<([^>]+)>)/ig, '')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/&#39;/g, "'");
  }

  checkoutAttribute = (e) => {
    e.preventDefault();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let error = false;
    let errorattribute = [];
    if (this.state.dealID.length > 0) {
      this.state.dealID.map((data, index) => {
        let deals = ''; let attributes = '';
        if (this.state.topDeal && this.state.topDeal.child_deals) {
          deals = this.state.topDeal.child_deals.filter((item) => item.dealID == data);
          if (deals[0].attributes && JSON.parse(deals[0].attributes).length > 0) {
            attributes = JSON.parse(deals[0].attributes);
          }
        }
        let attribute = [];
        if (!isEmpty(this.state.attribute[data])) {
          attribute = this.state.attribute[data];
        }
        if (isEmpty(attribute)) {
          error = true;
          errorattribute[data] = 'Please Select All Attributes';
        } else {
          if (!isEmpty(attributes)) {
            attributes.map((attrdata, attrindx) => {
              if (!attribute[attrindx] && isEmpty(attribute[attrindx])) {
                error = true;
                errorattribute[data] = 'Please Select All Attributes';
              }
            })
          }
        }
      });

      if (isEmpty(this.state.placeBidAmount)) {
        error = true;
        this.setState({ placeBidAmountError: 'red' });
      }

      if (isEmpty(this.state.topDeal.lastAuctionAmount)) {
        if (parseFloat(this.state.topDeal.offerPrice) > parseFloat(this.state.placeBidAmount)) {
          error = true;
          this.setState({ placeBidAmountMinError: "Sorry, You have to bid at least " + this.state.topDeal.offerPrice });
        }
      } else if (!isEmpty(this.state.topDeal.bidIncrements) && !isEmpty(this.state.topDeal.lastAuctionAmount)) {
        if ((parseFloat(this.state.topDeal.lastAuctionAmount) + parseFloat(this.state.topDeal.bidIncrements)) > parseFloat(this.state.placeBidAmount)) {
          let bidIncrementAmt = parseFloat(this.state.topDeal.lastAuctionAmount) + parseFloat(this.state.topDeal.bidIncrements);
          error = true;
          this.setState({ placeBidAmountMinError: "Sorry, You have to bid more than " + bidIncrementAmt });
        }
      } else {
        if (parseFloat(this.state.topDeal.lastAuctionAmount) >= parseFloat(this.state.placeBidAmount)) {
          error = true;
          this.setState({ placeBidAmountMinError: "Sorry, You have to bid more than " + this.state.topDeal.lastAuctionAmount });
        }
      }
    }

    this.setState({ errorattribute: errorattribute });
    if (error === false) {
      if (this.state.dealID.length > 0) {
        this.state.dealID.map((data, index) => {
          isLoading = "true";
          console.log('token3', cookies.get("token"), this.state.notUnique);
          if (isEmpty(cookies.get("token")) || this.state.notUnique) {
            let d = new Date();
            let time = d.getTime();
            let random = Math.floor(1000 + Math.random() * 9000);
            let cartTime = time + random + rand.generate();
            d.setTime(time + 480 * 60 * 1000);
            cookies.set("token", cartTime, { path: "/", expires: d });
          }
          console.log('token4', cookies.get("token"));
          let attribute = [];
          if (!isEmpty(this.state.attribute[data])) {
            attribute = this.state.attribute[data];
          }
          if (data !== "" && cookies.get("token") !== "" && !isEmpty(attribute)) {
            this.props.addToCart({
              dealID: data,
              userKey: cookies.get("token"),
              quantity: (this.state.quantity) ? this.state.quantity : 1,
              placeBidAmount: (this.state.placeBidAmount) ? this.state.placeBidAmount : '',
              buyNowOption: (this.state.topDeal.buyNowOption) ? this.state.topDeal.buyNowOption : '',
              proposalType: (this.state.proposalType) ? this.state.proposalType : '',
              sendAsGift: (this.state.recipientName) ? 1 : 0,
              recipientName: this.state.recipientName,
              recipientEmail: this.state.recipientEmail,
              personalMessage: this.state.personalMessage,
              marketID: (siteData && siteData.default_city) ? siteData.default_city : '',
              attribute: attribute,
              lang: this.state.default_lang,
            });
          } else {
            isLoading = "false";
            let errorattribute = [];
            errorattribute[data] = 'Please Select All Attributes';
            this.setState({ errorattribute: errorattribute });
          }
        });
      } else {
        this.setState({ show: true });
        this.setState({ error: "Please choose minimum one option.", errorattribute: [] });
      }
    }
  }


  handleAttribute = (e) => {
    let dealid = e.target.attributes.getNamedItem("data-name").value;
    let index = e.target.attributes.getNamedItem("data-id").value;
    let attrname = e.target.attributes.getNamedItem("data-value").value;
    attrname = '"' + attrname + '"';
    let attribute = !isEmpty(this.state.attribute) ? this.state.attribute : [];
    if (!attribute[dealid]) {
      attribute = Object.assign(attribute, { [dealid]: { [index]: { [attrname]: e.target.value } } });
    }

    if (!attribute[dealid][index]) {
      if (Object.entries(attribute[dealid]).length === 0 && attribute[dealid].constructor === Object) {
        attribute[dealid] = { [index]: { [attrname]: e.target.value } };
      }
      else {
        attribute[dealid] = Object.assign(attribute[dealid], { [index]: { [attrname]: e.target.value } });
      }
    }

    if (attribute[dealid][index]) {
      if (!attribute[dealid][index][attrname]) {
        attribute[dealid][index] = Object.assign(attribute[dealid][index], { [attrname]: e.target.value });
      }
      else {
        attribute[dealid][index][attrname] = e.target.value;
      }
    }
    this.setState({ attribute: attribute });
  }

  hoverOff = (e) => {
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  submitAsGift(e) {
    let validate = this.validate();
    if (validate) {
      if (!isEmpty(this.state.topDeal.child_deals)) {
        this.addToCartAttribute(e);
      } else {
        this.addToCart(e);
      }
    }
  }

  validate = () => {
    let response = true;

    if (!this.state.placeBidAmount) {
      response = false;
      this.setState({ placeBidAmountError: 'red' });
    }

    if (isEmpty(this.state.topDeal.lastAuctionAmount)) {
      if (parseFloat(this.state.topDeal.offerPrice) > parseFloat(this.state.placeBidAmount)) {
        response = false;
        this.setState({ placeBidAmountMinError: "Sorry, You have to bid at least " + this.state.topDeal.offerPrice });
      }
    } else if (!isEmpty(this.state.topDeal.bidIncrements) && !isEmpty(this.state.topDeal.lastAuctionAmount)) {
      if ((parseFloat(this.state.topDeal.lastAuctionAmount) + parseFloat(this.state.topDeal.bidIncrements)) > parseFloat(this.state.placeBidAmount)) {
        let bidIncrementAmt = parseFloat(this.state.topDeal.lastAuctionAmount) + parseFloat(this.state.topDeal.bidIncrements);
        response = false;
        this.setState({ placeBidAmountMinError: "Sorry, You have to bid more than " + bidIncrementAmt });
      }
    } else {
      if (parseFloat(this.state.topDeal.lastAuctionAmount) >= parseFloat(this.state.placeBidAmount)) {
        response = false;
        this.setState({ placeBidAmountMinError: "Sorry, You have to bid more than " + this.state.topDeal.lastAuctionAmount });
      }
    }

    return response;
  }

  closeModel = () => {
    this.setState({ modelShow: false, placeBidAmount: '' });
  }

  handleChange(e) {
    if (`this.state.${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ placeBidAmount: e.target.value })
    this.setState({ [e.target.name]: e.target.value });
  }

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang;
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
      default_lang: lang
    });

    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang);
    this.props.getMenuList({ page: 1, lang: lang, cityID: siteData.default_city });
    if (cookies.get('token')) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({ 'userKey': cookies.get('token'), lang: lang });
    }
  }

  handleModel = () => {
    if (!isEmpty(this.state.topDeal.child_deals)) {
      if (this.state.dealID.length > 0) {
        this.setState({ modelShow: true });
      } else {
        this.setState({ show: true });
        this.setState({ error: "Please choose minimum one option." });
        this.setState({ modelShow: false });
      }
    } else {
      this.setState({
        placeBidAmount: '',
        placeBidAmountError: '',
        placeBidAmountMinError: '',
      });
      this.setState({ modelShow: true });
    }
  }

  ShowAttribute = (e) => {
    e.preventDefault();
    const prevdeals = !isEmpty(this.state.dealID) ? this.state.dealID : [];
    if (this.state.dealID.length > 0 && this.state.topDeal && !isEmpty(this.state.topDeal.child_deals)) {
      this.setState({ attributeShow: true });
    } else if (this.state.topDeal && isEmpty(this.state.topDeal.child_deals) && this.state.topDeal.dealID) {
      const dealID = this.state.dealID;
      if (!prevdeals.includes("" + this.state.topDeal.dealID + "")) {
        dealID.push(this.state.topDeal.dealID);
      }
      this.setState({ attributeShow: true, dealID: dealID });
    } else {
      this.setState({ show: true });
      this.setState({ error: "Please choose minimum one option." });
    }
  }

  attributeclose = (e) => {
    this.setState({ attributeShow: false, attribute: [] });
  }

  handleDismiss() {
    this.setState({ show: false, error: '' });
  }

  handleShow() {
    this.setState({ show: true });
  }

  addToCart = (e) => {
    console.log('this.state.topDeal', this.state.topDeal.buyNowOption)
    console.log('this.state.placeBidAmount', this.state.placeBidAmount)
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    isLoading = "true";
    console.log('token1', cookies.get("token"), this.state.notUnique);
    if (isEmpty(cookies.get("token")) || this.state.notUnique) {
      let d = new Date();
      let time = d.getTime();
      let random = Math.floor(1000 + Math.random() * 9000);
      let cartTime = time + random + rand.generate();
      d.setTime(time + 480 * 60 * 1000);
      cookies.set("token", cartTime, { path: "/", expires: d });
    }
    console.log('token2', cookies.get("token"));
    let dealID = this.props.route.match.params.dealID
      ? this.props.route.match.params.dealID.split("-")
      : "";

    if (dealID[0] !== "" && cookies.get("token") !== "") {
      this.props.addToCart({
        dealID: (this.state.topDeal.child_deals) ? e.target.attributes.getNamedItem("data-id").value : this.state.topDeal.dealID,
        userKey: cookies.get("token"),
        quantity: (this.state.quantity) ? this.state.quantity : 1,
        placeBidAmount: (this.state.placeBidAmount) ? this.state.placeBidAmount : '',
        buyNowOption: (this.state.topDeal.buyNowOption) ? this.state.topDeal.buyNowOption : '',
        proposalType: (this.state.proposalType) ? this.state.proposalType : '',
        sendAsGift: (this.state.recipientName) ? 1 : 0,
        recipientName: this.state.recipientName,
        recipientEmail: this.state.recipientEmail,
        personalMessage: this.state.personalMessage,
        marketID: (siteData && siteData.default_city) ? siteData.default_city : '',
        lang: this.state.default_lang,
      });
    }
  }

  handleAttributes = e => {
    const dealID = this.state.dealID;

    let index;

    if (e.target.checked) {
      dealID.push(e.target.value);
    } else {
      index = dealID.indexOf(e.target.value);
      dealID.splice(index, 1);
    }


    this.setState({ dealID: dealID });
    this.setState({ error: "" });
  };


  addToCartAttribute = e => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    e.preventDefault();
    if (this.state.dealID.length > 0) {
      this.state.dealID.map((data, index) => {
        isLoading = "true";
        console.log('token5', cookies.get("token"), this.state.notUnique);
        if (isEmpty(cookies.get("token")) || this.state.notUnique) {
          let d = new Date();
          let time = d.getTime();
          let random = Math.floor(1000 + Math.random() * 9000);
          let cartTime = time + random + rand.generate();
          d.setTime(time + 480 * 60 * 1000);
          cookies.set("token", cartTime, { path: "/", expires: d });
        }
        console.log('token6', cookies.get("token"));
        if (data !== "" && cookies.get("token") !== "") {
          this.props.addToCart({
            dealID: data,
            userKey: cookies.get("token"),
            quantity: (this.state.quantity) ? this.state.quantity : 1,
            sendAsGift: (this.state.recipientName) ? 1 : 0,
            recipientName: this.state.recipientName,
            recipientEmail: this.state.recipientEmail,
            personalMessage: this.state.personalMessage,
            marketID: (siteData && siteData.default_city) ? siteData.default_city : '',
            lang: this.state.default_lang,
          });
          this.setState({disabled: true});
        }
      });
    } else {
      this.setState({ show: true });
      this.setState({ error: "Please choose minimum one option." });
    }
  };

  pagination = () => {
    this.setState({ load_more: true });
    limit = limit + this.state.perPage;
    const postData = {
      limit: limit,
      giftvoucher: "no",
    };

    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let default_city = '';
    if (siteData && siteData.default_city) {
      default_city = siteData.default_city;
    }

    if (default_city) {
      postData.cityID = default_city;
    }

    this.props.currentDealList(postData);
  };

  handlePageChange = page => {
    isLoading = "true";
    this.setState({
      currentPage: page
    });
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let default_city = '';

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }

    if (!this.state.default_city || this.state.default_city != siteData.default_city) {
      if (siteData && siteData.default_city) {
        default_city = siteData.default_city;
      }
    }
    const postData = {
      page: page,
      latitude: "26.846695",
      longitude: "80.946167",
      limit: this.state.limit,
      geolocation: "off",
      giftvoucher: "no",
    };

    if (default_city) {
      postData.cityID = default_city;
    }

    let affiliateID = this.props.route.match.params.affiliateID
      ? this.props.route.match.params.affiliateID
      : "";

    let ispreview = 0;
    if (this.props.route.match.params && this.props.route.match.params.cityID && this.props.route.match.params.cityID == 'preview') {
      ispreview = 1;
    }

    let dealID = this.props.route.match.params.dealID
      ? this.props.route.match.params.dealID.split("-")
      : "";
    if (dealID[0] !== "") {
      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      let user_id = (localStorage.getItem('user_id')) ? localStorage.getItem('user_id') : '';
      this.props.dealDetail({ dealID: parseInt(dealID[0]) ? dealID[0] : this.props.route.match.params.dealID, affiliateID: affiliateID, cityID: (siteData.default_city) ? siteData.default_city : "", lang: ((siteData.default_lang) ? siteData.default_lang : ''), preview: ispreview, userID: (user_id) ? user_id : "" });
      if (cookies.get("affiliateID") != affiliateID && affiliateID != "") {
        cookies.remove("affiliateID");
      }
      if (affiliateID != "") {
        if (isEmpty(cookies.get("affiliateID"))) {
          let d = new Date();
          d.setTime(d.getTime() + 480 * 60 * 1000);
          cookies.set(
            "affiliateID",
            {
              affiliateID: affiliateID,
              dealID: dealID[0]
            },
            { path: "/", expires: d }
          );
        }
      }
    }

    if (siteData && siteData.default_lang) {
      postData.lang = siteData.default_lang;
    }

    this.props.currentDealList(postData);
  };

  onSearch = val => {
    this.handleSearch(val);
  };

  handleSearch(val) {
    const postData = {
      page: this.state.currentPage,
      latitude: this.props.coords ? this.props.coords.latitude : "26.846695",
      longitude: this.props.coords ? this.props.coords.longitude : "80.946167",
      search: val,
      limit: this.state.limit,
      geolocation: "off",
      giftvoucher: "no",
    };

    if (val.length !== 0) {
      this.props.currentDealList(postData);
    } else {
      this.handlePageChange();
    }
  }

  componentWillMount() {
    this.props.clearAlert();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if (siteData) {
      this.setState({ siteDomain: siteData.siteDomain, default_city: siteData.default_city, multi_lang: siteData.multi_lang, lang: siteData.lang, default_lang: siteData.default_lang });
    }
    if (this.props.route.match.params && this.props.route.match.params.cityID) {
      //let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      this.setState({
        default_city: siteData.default_city//this.props.route.match.params.cityID
      });
      // siteData.default_city = this.props.route.match.params.cityID;
      // localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    }
    this.handleDismiss();
    this.handlePageChange(1);
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,

        });
      }
    }

    if (siteData) {
      if (siteData.default_city) {
        this.setState({
          notifications: siteData.notifications,
        });
      }
      if (siteData.siteDomain == 'https://www.idealgolfer.com' || siteData.siteName == 'iDealGolfer') {
        this.setState({
          activeTab: 2,
        });
      }
      this.setState({ fontFamilies: siteData.font_families });
    }
    this.updateWindowDimensions();
    if (!isEmpty(cookies.get("token"))) {
      console.log('token1get', cookies.get("token"));
      this.props.CheckUserKey({ 'userKey': cookies.get("token") });
    }
    window.addEventListener('resize', this.updateWindowDimensions);
    this.handleDismiss();
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  handleLanguageChange(lang) {
    isLoading = "true";
    this.setState({
      currentPage: this.state.currentPage,
    });
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let default_city = '';
    if (!this.state.default_city || this.state.default_city != siteData.default_city) {
      if (siteData && siteData.default_city) {
        default_city = siteData.default_city;
      }
    }

    const postData = {
      page: this.state.currentPage,
      latitude: "26.846695",
      longitude: "80.946167",
      limit: this.state.limit,
      geolocation: "off",
      giftvoucher: "no",
    };

    if (default_city) {
      postData.cityID = default_city;
    }

    let affiliateID = this.props.route.match.params.affiliateID
      ? this.props.route.match.params.affiliateID
      : "";

    let ispreview = 0;
    if (this.props.route.match.params && this.props.route.match.params.cityID && this.props.route.match.params.cityID == 'preview') {
      ispreview = 1;
    }

    let dealID = this.props.route.match.params.dealID
      ? this.props.route.match.params.dealID.split("-")
      : "";
    if (dealID[0] !== "") {
      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      let user_id = (localStorage.getItem('user_id')) ? localStorage.getItem('user_id') : '';
      this.props.dealDetail({ dealID: parseInt(dealID[0]) ? dealID[0] : this.props.route.match.params.dealID, affiliateID: affiliateID, cityID: (siteData.default_city) ? siteData.default_city : "", lang: lang, preview: ispreview, userID: (user_id) ? user_id : "" });
      if (cookies.get("affiliateID") != affiliateID && affiliateID != "") {
        cookies.remove("affiliateID");
      }
      if (affiliateID != "") {
        if (isEmpty(cookies.get("affiliateID"))) {
          let d = new Date();
          d.setTime(d.getTime() + 480 * 60 * 1000);
          cookies.set(
            "affiliateID",
            {
              affiliateID: affiliateID,
              dealID: dealID[0]
            },
            { path: "/", expires: d }
          );
        }
      }
    }

    if (this.state.default_lang) {
      postData.lang = lang;
    }

    this.props.currentDealList(postData);
  }

  componentWillReceiveProps(nextProps) {
    let lang = this.state.default_lang ? this.state.default_lang : 'en';
    if (nextProps.language) {
      if (this.state.default_lang !== nextProps.language) {
        lang = nextProps.language;
        this.setState({ default_lang: nextProps.language });
        this.handleLanguageChange(nextProps.language);
      }
    }

    if (nextProps.UserKeyStatus) {
      if (nextProps.UserKeyStatus.response && nextProps.UserKeyStatus.response == "error") {
        this.setState({ notUnique: true });
      } else {
        this.setState({ notUnique: false });
      }
    }

    if (nextProps.currency) {
      this.setState({ currency: nextProps.currency, symbol: nextProps.symbol })
    }

    if (nextProps.themeData) {
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          text_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
      if (lang == 'fr') {
        this.setState({ NoRecord: nextProps.themeData.french_NoRecord });
      } else {
        this.setState({ NoRecord: nextProps.themeData.NoRecord });
      }
    }

    // Top Deal
    if (this.props.topDeal != nextProps.topDeal) {
      this.handleDismiss();
      if (nextProps.topDeal) {
        if (nextProps.topDeal.expiredDeal && nextProps.topDeal.expiredDeal == 1) {
          this.context.router.history.push('/');
        }
        isLoading = "false";
        this.setState({ topDeal: nextProps.topDeal, merchantID: nextProps.topDeal.merchantID });

        if (nextProps.topDeal.attributes) {
          let attribute = JSON.parse(nextProps.topDeal.attributes);
          if (attribute.length > 0) {
            this.setState({ ClickToSelect: 1 });
          } else {
            this.setState({ ClickToSelect: 0 });
          }
        }
        if (nextProps.topDeal.offer_meta_title !== '' && nextProps.topDeal.offer_meta_title !== null) {
          document.title = nextProps.topDeal.offer_meta_title;
        }

        if (nextProps.topDeal.offer_description != '' && nextProps.topDeal.offer_description !== null) {
          let meta = document.querySelector("meta[name*='description']");
          meta.content = nextProps.topDeal.offer_description;
        }

        if (nextProps.topDeal.writeUp != '' && nextProps.topDeal.writeUp !== null) {
          let ogdescription = document.querySelector("meta[property*='og:description']");
          ogdescription.content = nextProps.topDeal.writeUp;
        }

        if (nextProps.topDeal.mainDealText != '' && nextProps.topDeal.mainDealText !== null) {
          let ogtitle = document.querySelector("meta[property*='og:title']");
          ogtitle.content = ReactHtmlParser(nextProps.topDeal.mainDealText);
        }


        if (nextProps.topDeal && typeof nextProps.topDeal.dealImages !== 'undefined') {
          let ogimage = document.querySelector("meta[property*='og:image']");
          ogimage.content = nextProps.topDeal.dealImages[0].dealID;
        } else {

          let url = "data:image/jpeg;base64,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";
          let ogimage = document.querySelector("meta[property*='og:image']");
          ogimage.content = url;
        }

        if (nextProps.topDeal.highlights !== '') {
          this.setState({ topDealHighlights: (nextProps.topDeal.highlights) ? JSON.parse(nextProps.topDeal.highlights) : '' });
        }
        /*
        const postData = {
          page: this.state.currentPage,
          latitude: "26.846695",
          longitude: "80.946167",
          limit: this.state.limit,
          geolocation: "off",
          giftvoucher: "no",
          merchantID: nextProps.topDeal.merchantID,
        };
        let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
        let default_city = '';
        if(!this.state.default_city || this.state.default_city != siteData.default_city){
          if(siteData && siteData.default_city){
            default_city = siteData.default_city;
          }
        }
        if(!isEmpty(default_city)){
          postData.cityID = default_city;
        }else{
          postData.cityID = this.state.default_city ;
        }

        if(siteData && siteData.default_lang){
          postData.lang= siteData.default_lang;
        }

        this.props.currentDealList(postData);
        */

      }
    }
    // current deal
    if (this.props.curDeal != nextProps.curDeal) {
      if (nextProps.curDeal) {
        isLoading = "false";
        this.setState({ total: nextProps.curDeal.total });
        this.setState({ curDeal: nextProps.curDeal.data, load_more: 'no' });
      }
      // if (nextProps.curDeal && nextProps.curDeal.merchantStore.button) {
      //     this.setState({
      //       mbutton_color: nextProps.curDeal.merchantStore.button.button_color,
      //       mtext_color: nextProps.curDeal.merchantStore.button.button_color,
      //       mmouseover_color: nextProps.curDeal.merchantStore.button.mouseover_color,
      //     });
      // }else{
      //   this.setState({
      //     mbutton_color: '',
      //     mtext_color: '',
      //     mmouseover_color: '',
      //   });
      // }
    }

    if (this.props.couponStatus != nextProps.couponStatus) {
      if (nextProps.couponStatus) {
        let dealID = this.props.route.match.params.dealID
          ? this.props.route.match.params.dealID
          : "";
        if (dealID !== "") {
          isLoading = "false";
          this.context.router.history.push("/voucher/" + dealID + "/free");
        }
      }
    }

    if (this.props.cartStatus != nextProps.cartStatus) {
      if (nextProps.cartStatus) {
        if (nextProps.cartStatus.response == 'error') {
          isLoading = "false";
          this.props.clearAlert();
          this.handleShow();
          this.props.renderAlert("danger", nextProps.cartStatus.message);
          isLoading = "false";
          this.closeModel();
          window.scrollTo(0, 0);
        } else if (nextProps.topDeal.proposal_type == 11 || this.state.topDeal.proposal_type == 11) {
          isLoading = "false";
          this.closeModel();
          this.setState({ cartStatus: nextProps.cartStatus.data });
          this.context.router.history.push('/checkout');
        } else {
          isLoading = "false";
          this.closeModel();
          this.setState({ cartStatus: nextProps.cartStatus.data });
          this.context.router.history.push('/cart');
        }
      }
    }

    if (this.props.cartError !== nextProps.cartError) {
      if (nextProps.cartError) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("danger", nextProps.cartError);
        isLoading = "false";
        window.scrollTo(0, 0);
      }
    }

    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
        attributeShow: false
      });
    }
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction
    });
  }

  handleSubmit = dealID => {
    isLoading = "true";
    this.setState({ dealID: [] });
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let user_id = (localStorage.getItem('user_id')) ? localStorage.getItem('user_id') : '';
    this.props.dealDetail({ dealID: dealID, affiliateID: "", cityID: (siteData.default_city) ? siteData.default_city : "", lang: this.state.default_lang, userID: (user_id) ? user_id : "" });
    this.handleTabs(1);
  };

  generateCoupon = dealID => {
    isLoading = "true";
    this.context.router.history.push("/voucher/" + dealID + "/free");
  };

  handleTabs = (key) => {
    this.setState({ activeTab: key });
  }

  affiliateSetting = (list) => {
    const affiliateLogin = list.affiliateLogin;
    const affiliatePurchaseUrl = list.affiliatePurchaseUrl;
    let userLogin = (localStorage.getItem('user_id')) ? localStorage.getItem('user_id') : '';
    if (affiliateLogin == 'Enable' && userLogin == '') {
      window.alert("Login required!");
      this.context.router.history.push("/login");
    } else {
      window.open(affiliatePurchaseUrl, "_blank");
    }

  }

  render() {
    let userLogin = (localStorage.getItem('user_id')) ? localStorage.getItem('user_id') : '';
    let checkBoxDeal = this.state.dealID
    const { index, direction, width } = this.state;
    const isMobile = width >= 600;
    let images = (this.state.topDeal) ? this.state.topDeal.dealImages : '';

    // Timer option
    let timerOption = 'no';
    if (this.state.topDeal) {
      let dt1 = new Date(this.state.topDeal.today_date);
      let dt2 = new Date(this.state.topDeal.expiry_date);

      let diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= (60 * 60);

      if (diff <= parseInt(this.state.topDeal.timerStartInHour) && this.state.topDeal.timerStartInHour > 0) {
        timerOption = 'yes';
      }

      if (this.state.topDeal.timerStartInHour === '' || this.state.topDeal.timerStartInHour == 0) {
        timerOption = 'yes';
      }
    }

    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;

    let currentDeals, upDeal, totalDeal, position, parDealID;
    if (!isEmpty(this.state.curDeal)) {
      totalDeal = this.state.curDeal.length;

      if (totalDeal > 2) {
        position = 2;
      } else {
        position = totalDeal - 1;
      }
      if (!isEmpty(this.props.route.match.params) && this.props.route.match.params.dealID) {
        parDealID = this.props.route.match.params.dealID;
      } else {
        parDealID = '';
      }
      currentDeals = this.state.curDeal.map((deal, index) => {
        let newDealPrice = '', newRetailPrice = '';
        if (!isEmpty(deal.child_deals)) {
          deal.child_deals.map((deal, index) => {
            if (now.isAfter(deal.startDateTime) && now.isBefore(deal.expiryDateTime) && newDealPrice == '') {
              newDealPrice = deal.offerPrice;
              newRetailPrice = deal.retailPrice;
            }
          })
        } else {
          newDealPrice = deal.offerPrice;
          newRetailPrice = deal.retailPrice;
        }
        if (index >= 0 && deal.offer_url != parDealID && this.state.topDeal.dealID && deal.dealID != this.state.topDeal.dealID) {
          return <React.Fragment key={Math.random() + index}>
            {(index == position) ?
              <React.Fragment>

                <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
                  <div className="deal-container shadow">
                    <div className="deal-image">
                      {deal.proposal_type == 11 ? (
                        <Link
                          to={(deal.offer_url) ? `/auction-detail/${deal.offer_url}` : `/auction-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                          onClick={this.handleSubmit.bind(this, deal.dealID)}
                        >
                          <Image
                            src={
                              deal.dealImage.includes('http') ? (deal.dealImage ? deal.dealImage : noImg) : (deal.dealImage ? (deal.imageurl + deal.dealImage) : noImg)
                            }
                            alt={deal.img_alt_text}
                            title={deal.img_text}
                            description={deal.img_desc}
                            responsive
                          />
                        </Link>
                      ) : (
                        <Link
                          to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                          onClick={this.handleSubmit.bind(this, deal.dealID)}
                        >
                          <Image
                            src={
                              deal.dealImage.includes('http') ? (deal.dealImage ? deal.dealImage : noImg) : (deal.dealImage ? (deal.imageurl + deal.dealImage) : noImg)
                            }
                            alt={deal.img_alt_text}
                            title={deal.img_text}
                            description={deal.img_desc}
                            responsive
                          />
                        </Link>
                      )}

                    </div>
                    <h2 className="dealname">{ReactHtmlParser((deal.mainDealText != '') ? deal.mainDealText : deal.dealText)}</h2>
                    <div className="merchant">
                      {(deal.useProdName == 0) ? deal.merchantName : (deal.prodName) ? deal.prodName : deal.merchantName}
                    </div>

                    {newDealPrice > 0 ? (
                      <div className="prices">
                        {newDealPrice == newRetailPrice ? (
                          <span className="percent" />
                        ) : (
                          <React.Fragment>
                            {deal.showDiscount == '1' && deal.proposal_type != 11 &&
                              <span className="percent" style={{ color: this.state.text_color }}>
                                -{Math.round(100 - (newDealPrice / newRetailPrice * 100))}%
                              </span>
                            }
                          </React.Fragment>
                        )}
                        {deal.showDiscount == '1' && deal.proposal_type != 11 &&
                          <Currency amount={newRetailPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                        }
                        {deal.proposal_type == 11 && deal.lastAuctionAmount > 0 ? (
                          <Currency amount={deal.lastAuctionAmount} default_lang={this.state.default_lang} className="current" default_currency={this.state.currency} />
                        ) : (
                          <Currency amount={newDealPrice} default_lang={this.state.default_lang} className="current" default_currency={this.state.currency} />
                        )}
                      </div>
                    ) : (
                      <div className="prices">
                        {deal.proposal_type == 7 ? (
                          <span className="percent" style={{ color: this.state.text_color }}>
                            {deal.percentageOff}% OFF
                          </span>
                        ) :
                          <span className="percent" style={{ color: this.state.text_color }}>
                            {
                              deal.proposal_type == 6
                                ? languageConfig[this.state.default_lang].proposal_coupon
                                : languageConfig[this.state.default_lang].free_text
                            }
                          </span>
                        }
                      </div>
                    )}
                    <div className="short-disc">
                      {deal.writeUp
                        ? ReactHtmlParser(deal.writeUp.substring(0, 180).replace(/<[^>]+>/g, ''))
                        : ""}
                    </div>
                    <div className="deal-footer">
                      {(isIE == false && isEdge == false && isMobile) ?
                        (deal.proposal_type == 11) ?
                          <Link
                            to={(deal.offer_url) ? `/auction-detail/${deal.offer_url}` : `/auction-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                            onClick={this.handleSubmit.bind(this, deal.dealID)}
                            replace
                            className="btn btn-deal"
                            style={{ backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                            data-id={deal.dealID}
                            onMouseEnter={this.hoverOn}
                            onMouseLeave={this.hoverOff}
                          >
                            {(deal.sold_out && deal.sold_out == "true") ? languageConfig[this.state.default_lang].auction_ended : languageConfig[this.state.default_lang].auction_view}
                          </Link>
                          :
                          <Link
                            to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                            onClick={this.handleSubmit.bind(this, deal.dealID)}
                            replace
                            className="btn btn-deal"
                            style={{ backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                            data-id={deal.dealID}
                            onMouseEnter={this.hoverOn}
                            onMouseLeave={this.hoverOff}
                          >
                            {(deal.sold_out && deal.sold_out == "true") ? languageConfig[this.state.default_lang].sold_out : languageConfig[this.state.default_lang].view}
                          </Link>
                        :
                        (deal.proposal_type == 11) ?
                          <Link
                            to={(deal.offer_url) ? `/auction-detail/${deal.offer_url}` : `/auction-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                            onClick={this.handleSubmit.bind(this, deal.dealID)}
                            replace
                            className="btn btn-deal"
                            style={{ backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                            data-id={deal.dealID}
                          >
                            {(deal.sold_out && deal.sold_out == "true") ? languageConfig[this.state.default_lang].auction_ended : languageConfig[this.state.default_lang].auction_view}
                          </Link>
                          :
                          <Link
                            to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                            onClick={this.handleSubmit.bind(this, deal.dealID)}
                            replace
                            className="btn btn-deal"
                            style={{ backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                            data-id={deal.dealID}
                          >
                            {(deal.sold_out && deal.sold_out == "true") ? languageConfig[this.state.default_lang].sold_out : languageConfig[this.state.default_lang].view}
                          </Link>
                      }
                    </div>
                  </div>
                </Col>
                {(this.state.notifications) &&
                  this.state.notifications.map((data, index) =>
                    (data.position == 'third_position') &&
                    <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
                      <div className={data.content_type == 'Ads Script' ? "deal-container ads" : "deal-container shadow"}>
                        <React.Fragment>
                          {(data.displayimage != '' || data.mobileappdisplay_image != '') ?
                            (this.state.width > 480 && data.remove_image == 1) ?
                              <a href={this.getValidUrl(data.display_image_link)} target="_blank"><Image src={data.displayimage} /></a>
                              : (this.state.width < 480 && data.remove_mobile_app_image == 1) ?
                                <a href={this.getValidUrl(data.display_image_link)} target="_blank"><Image src={data.mobileappdisplay_image} /></a>
                                :
                                <React.Fragment>
                                  {data.content_type == 'Ads Script' ?
                                    data.scripttype == 'other' ?
                                      <ScriptSlot datas={data} />
                                      :
                                      <UseDfpSlot datas={data} />
                                    :
                                    ((data.message != '') ? ReactHtmlParser(data.message) : '')
                                  }
                                </React.Fragment>
                            :
                            <React.Fragment>
                              {data.content_type == 'Ads Script' ?
                                data.scripttype == 'other' ?
                                  <ScriptSlot datas={data} />
                                  :
                                  <UseDfpSlot datas={data} />
                                :
                                ((data.message != '') ? ReactHtmlParser(data.message) : '')
                              }
                            </React.Fragment>
                          }
                        </React.Fragment>
                      </div>
                    </Col>
                  )
                }
              </React.Fragment>
              :
              <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
                <div className="deal-container shadow">
                  <div className="deal-image">
                    {deal.proposal_type == 11 ? (
                      <Link
                        to={(deal.offer_url) ? `/auction-detail/${deal.offer_url}` : `/auction-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                        onClick={this.handleSubmit.bind(this, deal.dealID)}
                        replace
                      >
                        <Image
                          src={
                            deal.dealImage.includes('http') ? (deal.dealImage ? deal.dealImage : noImg) : (deal.dealImage ? (deal.imageurl + deal.dealImage) : noImg)
                          }
                          alt={deal.img_alt_text}
                          title={deal.img_text}
                          description={deal.img_desc}
                          responsive
                        />
                      </Link>
                    ) : (
                      <Link
                        to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                        onClick={this.handleSubmit.bind(this, deal.dealID)}
                        replace
                      >
                        <Image
                          src={
                            deal.dealImage.includes('http') ? (deal.dealImage ? deal.dealImage : noImg) : (deal.dealImage ? (deal.imageurl + deal.dealImage) : noImg)
                          }
                          alt={deal.img_alt_text}
                          title={deal.img_text}
                          description={deal.img_desc}
                          responsive
                        />
                      </Link>
                    )}
                  </div>
                  <h2 className="dealname">{ReactHtmlParser((deal.mainDealText != '') ? deal.mainDealText : deal.dealText)}</h2>
                  <div className="merchant">
                    {(deal.useProdName == 0) ? deal.merchantName : (deal.prodName) ? deal.prodName : deal.merchantName}
                  </div>

                  {newDealPrice > 0 ? (
                    <div className="prices">
                      {newDealPrice == newRetailPrice ? (
                        <span className="percent" />
                      ) : (
                        <React.Fragment>
                          {deal.showDiscount == '1' && deal.proposal_type != 11 &&
                            <span className="percent" style={{ color: this.state.text_color }}>
                              -{Math.round(100 - (newDealPrice / newRetailPrice * 100))}%
                            </span>
                          }
                        </React.Fragment>
                      )}
                      {deal.showDiscount == '1' && deal.proposal_type != 11 &&
                        <Currency amount={newRetailPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                      }
                      {deal.proposal_type == 11 && deal.lastAuctionAmount > 0 ? (
                        <Currency amount={deal.lastAuctionAmount} default_lang={this.state.default_lang} className="current" default_currency={this.state.currency} />
                      ) : (
                        <Currency amount={newDealPrice} default_lang={this.state.default_lang} className="current" default_currency={this.state.currency} />
                      )}
                    </div>
                  ) : (
                    <div className="prices">
                      {deal.proposal_type == 7 ? (
                        <span className="percent" style={{ color: this.state.text_color }}>
                          {deal.percentageOff}% OFF
                        </span>
                      ) :
                        <span className="percent" style={{ color: this.state.text_color }}>
                          {
                            deal.proposal_type == 6
                              ? languageConfig[this.state.default_lang].proposal_coupon
                              : languageConfig[this.state.default_lang].free_text
                          }
                        </span>
                      }
                    </div>
                  )}

                  <div className="short-disc">
                    {deal.writeUp
                      ? ReactHtmlParser(deal.writeUp.substring(0, 180).replace(/<[^>]+>/g, ''))
                      : ""}
                  </div>
                  <div className="deal-footer">
                    {(isIE == false && isEdge == false && isMobile) ?
                      (deal.proposal_type == 11) ?
                        <Link
                          to={(deal.offer_url) ? `/auction-detail/${deal.offer_url}` : `/auction-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                          onClick={this.handleSubmit.bind(this, deal.dealID)}
                          replace
                          className="btn btn-deal"
                          style={{ backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                          data-id={deal.dealID}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                        >
                          {(deal.sold_out && deal.sold_out == "true") ? languageConfig[this.state.default_lang].auction_ended : languageConfig[this.state.default_lang].auction_view}
                        </Link>
                        :
                        <Link
                          to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                          onClick={this.handleSubmit.bind(this, deal.dealID)}
                          replace
                          className="btn btn-deal"
                          style={{ backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                          data-id={deal.dealID}
                          onMouseEnter={this.hoverOn}
                          onMouseLeave={this.hoverOff}
                        >
                          {(deal.sold_out && deal.sold_out == "true") ? languageConfig[this.state.default_lang].sold_out : languageConfig[this.state.default_lang].view}
                        </Link>
                      :
                      (deal.proposal_type == 11) ?
                        <Link
                          to={(deal.offer_url) ? `/auction-detail/${deal.offer_url}` : `/auction-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                          onClick={this.handleSubmit.bind(this, deal.dealID)}
                          replace
                          className="btn btn-deal"
                          style={{ backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                          data-id={deal.dealID}
                        >
                          {(deal.sold_out && deal.sold_out == "true") ? languageConfig[this.state.default_lang].auction_ended : languageConfig[this.state.default_lang].auction_view}
                        </Link>
                        :
                        <Link
                          to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                          onClick={this.handleSubmit.bind(this, deal.dealID)}
                          replace
                          className="btn btn-deal"
                          style={{ backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                          data-id={deal.dealID}
                        >
                          {(deal.sold_out && deal.sold_out == "true") ? languageConfig[this.state.default_lang].sold_out : languageConfig[this.state.default_lang].view}
                        </Link>
                    }
                  </div>
                </div>
              </Col>
            }
          </React.Fragment>
        }
      });
    }

    const style = {
      width: "95%",
      height: "450px",
    };

    var points = [
      { lat: 26.851310, lng: -77.01 },
    ];
    var bounds = new this.props.google.maps.LatLngBounds();
    for (var i = 0; i < points.length; i++) {
      bounds.extend(points[i]);
    }

    let multiprice = '', retailPrice = '', saving_percent = '', saving_amount = '';
    if (!isEmpty(this.state.topDeal) && !isEmpty(this.state.topDeal.child_deals)) {
      this.state.topDeal.child_deals.map((deal, index) => {
        if (now.isAfter(deal.startDateTime) && now.isBefore(deal.expiryDateTime) && multiprice == '') {
          multiprice = deal.offerPrice;
          retailPrice = deal.retailPrice;
          saving_percent = deal.saving_percent;
          saving_amount = deal.saving_amount;
        }
      })
    }

    return (
      <React.Fragment>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="container">
          {(this.state.show && this.state.alertMessage !== "" && this.state.msgType) && (
            <div className="row">
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>Message:</strong> {this.state.alertMessage}
                </Alert>
              </div>
            </div>
          )}
          {!isEmpty(this.state.topDeal) ? (
            <div>
              <Row className="viewdeal-banner">
                <Col lg={8} md={8} sm={6} xs={12} >
                  {!isEmpty(this.state.topDeal.dealImages) && this.state.topDeal.dealImages.length > 1 ?
                    (<Carousel
                      activeIndex={index}
                      direction={direction}
                      onSelect={this.handleSelect}
                    >
                      {!isEmpty(this.state.topDeal.dealImages) ? (
                        this.state.topDeal.dealImages.map((topImg, index) => (
                          <Carousel.Item key={'crimg' + index}>
                            <Image responsive src={(topImg.dealID.includes('http://auction-images.imshopping.com')) ? topImg.dealID.replace("https://d266oi3blg1w2v.cloudfront.net/", "") : topImg.dealID} alt={topImg.img_alt_text} title={topImg.img_text} description={topImg.img_desc} />
                          </Carousel.Item>
                        ))
                      ) : (
                        <Carousel.Item>
                          <Image responsive src={noImg} />
                        </Carousel.Item>
                      )}
                    </Carousel>)
                    :
                    !isEmpty(this.state.topDeal.dealImages) ? (
                      this.state.topDeal.dealImages.map((topImg, index) => (
                        <div className="carousel-inner">
                          <div className="item active">
                            <Image responsive src={(topImg.dealID.includes('http://product-images.imshopping.com')) ? topImg.dealID.replace("https://d266oi3blg1w2v.cloudfront.net/", "") : topImg.dealID} alt={topImg.img_alt_text} title={topImg.img_text} description={topImg.img_desc} />
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="carousel-inner">
                        <div className="item active">
                          <Image responsive src={noImg} />
                        </div>
                      </div>
                    )
                  }
                </Col>
                <Col lg={4} md={4} sm={6} xs={12} className="pl-0">
                  <div className="bg-white bannerDealcontainer shadow text-center">
                    <div className="bannerDeal">
                      <h2 className="dealname">
                        {ReactHtmlParser((this.state.topDeal.child_deals) ? this.state.topDeal.mainDealText : this.state.topDeal.dealText)}
                      </h2>

                      <div className="deals-price">

                        {!isEmpty(this.state.topDeal.child_deals) ?
                          (multiprice == '0.00' || this.state.topDeal.offerPrice == '0.00') ?
                            <span className="price" style={{ display: this.state.topDeal.proposal_type == 7 ? "none" : "block" }}>
                              {
                                this.state.topDeal.proposal_type == 6
                                  ? languageConfig[this.state.default_lang].proposal_coupon
                                  : languageConfig[this.state.default_lang].free_text
                              }
                            </span>
                            : (this.state.topDeal.proposal_type == 11 && this.state.topDeal.lastAuctionAmount > 0) ?
                              <Currency amount={this.state.topDeal.lastAuctionAmount} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                              : (this.state.topDeal.proposal_type == 11 && this.state.topDeal.lastAuctionAmount == '' && this.state.topDeal.lastAuctionAmount == null) ?
                                <Currency amount={this.state.topDeal.offerPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                                : this.state.topDeal.proposal_type != 7 ?
                                  <Currency amount={(multiprice != '') ? multiprice : this.state.topDeal.offerPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                                  : null
                          :
                          (this.state.topDeal.offerPrice == '0.00') ?
                            <span className="price" style={{ display: this.state.topDeal.proposal_type == 7 ? "none" : "block" }}>
                              {
                                this.state.topDeal.proposal_type == 6
                                  ? languageConfig[this.state.default_lang].proposal_coupon
                                  : languageConfig[this.state.default_lang].free_text
                              }
                            </span>
                            : (this.state.topDeal.proposal_type == 11 && this.state.topDeal.lastAuctionAmount > 0) ?
                              <Currency amount={this.state.topDeal.lastAuctionAmount} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                              : (this.state.topDeal.proposal_type == 11 && this.state.topDeal.lastAuctionAmount == '' && this.state.topDeal.lastAuctionAmount == null) ?
                                <Currency amount={this.state.topDeal.offerPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                                : this.state.topDeal.proposal_type != 7 ?
                                  <Currency amount={this.state.topDeal.offerPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                                  : null
                        }
                        <h5 className="merchant text-center">
                          {(this.state.topDeal.useProdName == 0) ? this.state.topDeal.merchantName : (this.state.topDeal.prodName) ? this.state.topDeal.prodName : this.state.topDeal.merchantName}
                        </h5>
                        {(this.state.topDeal.sold_out == true) ?
                          <React.Fragment>
                            <div>
                              {!isEmpty(this.state.topDeal.child_deals) && this.state.topDeal.child_deals.map((deal, index) => (
                                (now.isAfter(deal.startDateTime) && now.isBefore(deal.expiryDateTime)) && (
                                  <Row>
                                    <Col md={12} xs={12} className="text-left">
                                      <FormGroup>
                                        {(!isEmpty(this.state.dealID)) ?
                                          <Checkbox
                                            onClick={this.handleAttributes}
                                            value={deal.dealID}
                                            disabled='disabled'
                                          >
                                            {deal.proposal_type == 11 && deal.lastAuctionAmount !== '' && deal.lastAuctionAmount !== null ? (
                                              <Currency amount={deal.lastAuctionAmount} default_lang={this.state.default_lang} className="strike" moretext={deal.dealText} default_currency={this.state.currency} />
                                            ) : (
                                              <Currency amount={deal.offerPrice} default_lang={this.state.default_lang} className="strike" moretext={deal.dealText} default_currency={this.state.currency} />
                                            )}
                                          </Checkbox>
                                          :
                                          <Checkbox
                                            onClick={this.handleAttributes}
                                            value={deal.dealID}
                                            checked={this.state.isChecked}
                                            disabled='disabled'
                                          >
                                            {deal.proposal_type == 11 && deal.lastAuctionAmount !== '' && deal.lastAuctionAmount !== null ? (
                                              <Currency
                                                amount={deal.lastAuctionAmount}
                                                default_lang={this.state.default_lang}
                                                className="strike"
                                                moretext={deal.dealText}
                                                default_currency={this.state.currency}
                                              />
                                            ) : (
                                              <Currency
                                                amount={deal.offerPrice}
                                                default_lang={this.state.default_lang}
                                                className="strike"
                                                moretext={deal.dealText}
                                                default_currency={this.state.currency}
                                              />
                                            )}
                                          </Checkbox>
                                        }
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )
                              ))}
                              <div className="add-cart">
                                {this.state.error ? (
                                  <div className="col-lg-12">
                                    <Notification type="danger">
                                      <span>
                                        <strong>Error:</strong> {this.state.error}
                                      </span>
                                    </Notification>
                                  </div>
                                ) : null}
                                <Link
                                  to="#"
                                  replace
                                  className="view-button btn btn-deal"
                                  style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                >
                                  {(this.state.topDeal.proposal_type != 11) ? languageConfig[this.state.default_lang].sold_out : languageConfig[this.state.default_lang].auction_ended}
                                </Link>
                              </div>

                            </div>
                          </React.Fragment>
                          :
                          <React.Fragment>
                            {!isEmpty(this.state.topDeal.child_deals) ? (
                              <div>
                                {this.state.topDeal.child_deals.map((deal, index) => (
                                  (now.isAfter(deal.startDateTime) && now.isBefore(deal.expiryDateTime)) && (
                                    <Row>
                                      <Col md={12} xs={12} className="text-left">
                                        <FormGroup>
                                          {(!isEmpty(this.state.dealID)) ?
                                            <Checkbox
                                              onClick={this.handleAttributes}
                                              value={deal.dealID}
                                              disabled={deal.sold_out == 'false' ? false : true}
                                            >
                                              {deal.proposal_type == 11 && deal.lastAuctionAmount !== '' && deal.lastAuctionAmount !== null ? (
                                                <Currency
                                                  amount={deal.lastAuctionAmount}
                                                  default_lang={this.state.default_lang}
                                                  className={deal.sold_out == 'false' ? '' : 'strike'}
                                                  moretext={deal.dealText}
                                                  default_currency={this.state.currency}
                                                />
                                              ) : (
                                                <Currency
                                                  amount={deal.offerPrice}
                                                  default_lang={this.state.default_lang}
                                                  className={deal.sold_out == 'false' ? '' : 'strike'}
                                                  moretext={deal.dealText}
                                                  default_currency={this.state.currency}
                                                />
                                              )}
                                            </Checkbox>
                                            :
                                            <Checkbox
                                              onClick={this.handleAttributes}
                                              value={deal.dealID}
                                              checked={this.state.isChecked}
                                              disabled={deal.sold_out == 'false' ? false : true}
                                            >
                                              {deal.proposal_type == 11 && deal.lastAuctionAmount !== '' && deal.lastAuctionAmount !== null ? (
                                                <Currency
                                                  amount={deal.lastAuctionAmount}
                                                  default_lang={this.state.default_lang}
                                                  className={deal.sold_out == 'false' ? '' : 'strike'}
                                                  moretext={deal.dealText}
                                                  default_currency={this.state.currency}
                                                />
                                              ) : (
                                                <Currency
                                                  amount={deal.offerPrice}
                                                  default_lang={this.state.default_lang}
                                                  className={deal.sold_out == 'false' ? '' : 'strike'}
                                                  moretext={deal.dealText}
                                                  default_currency={this.state.currency}
                                                />
                                              )}
                                            </Checkbox>
                                          }
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  )
                                ))}
                                <div className="add-cart">
                                  {this.state.error ? (
                                    <div className="col-lg-12">
                                      <Notification type="danger">
                                        <span>
                                          <strong>Error:</strong> {this.state.error}
                                        </span>
                                      </Notification>
                                    </div>
                                  ) : null}
                                  {(isIE == false && isEdge == false && isMobile) ?
                                    (this.state.topDeal.proposal_type != 11) ?
                                      


                                       <button
                                       className="view-button btn btn-deal"
                                        onClick={this.state.ClickToSelect ? this.ShowAttribute : this.addToCartAttribute}
                                        style={{marginLeft: '-1px !important'},{padding:'10px 126px !important'},{ backgroundColor: (this.state.hover && this.state.hoverID == 'Add To Cart') ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                        data-id={'Add To Cart'}
                                        onMouseEnter={this.hoverOn}
                                        onMouseLeave={this.hoverOff}
                                     disabled={this.state.disabled}
                                       >
                                        {this.state.ClickToSelect ? languageConfig[this.state.default_lang].click_to_select : languageConfig[this.state.default_lang].add_to_cart}

                                       </button> 


                                      :
                                      (this.state.ClickToSelect && this.state.topDeal.proposal_type == 11) ?
                                        <Button bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.ShowAttribute}><i className="glyphicon glyphicon-education" aria-hidden="true"></i> {languageConfig[this.state.default_lang].place_auction_bid}</Button>
                                        :
                                        <Button bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.handleModel}><i className="glyphicon glyphicon-education" aria-hidden="true"></i> {languageConfig[this.state.default_lang].place_auction_bid}</Button>
                                    :
                                    (this.state.topDeal.proposal_type != 11) ?
                                     

                                      <button
                                      className="view-button btn btn-deal"
                                        onClick={this.state.ClickToSelect ? this.ShowAttribute : this.addToCartAttribute}
                                        style={{marginLeft: '-1px !important'},{padding:'10px 126px !important'},{ backgroundColor: (this.state.hover && this.state.hoverID == 'Add To Cart') ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                        data-id={'Add To Cart'}
                                     disabled={this.state.disabled}
                                      >
                                        {this.state.ClickToSelect ? languageConfig[this.state.default_lang].click_to_select : languageConfig[this.state.default_lang].add_to_cart}

                                      </button>




                                      :
                                      (this.state.ClickToSelect && this.state.topDeal.proposal_type == 11) ?
                                        <Button bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.ShowAttribute}><i className="glyphicon glyphicon-education" aria-hidden="true"></i> {languageConfig[this.state.default_lang].place_auction_bid}</Button>
                                        :
                                        <Button bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.handleModel}><i className="glyphicon glyphicon-education" aria-hidden="true"></i> {languageConfig[this.state.default_lang].place_auction_bid}</Button>
                                  }
                                </div>
                              </div>
                            ) : (
                              <div>
                                {now.isBefore(this.state.topDeal.startDateTime) ? (
                                  <div>
                                    {(isIE == false && isEdge == false && isMobile) ?
                                      <a
                                        style={{ backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                        data-id={this.state.topDeal.dealID}
                                        onMouseEnter={this.hoverOn}
                                        onMouseLeave={this.hoverOff}
                                        className="view-button btn btn-danger"
                                      >
                                        {languageConfig[this.state.default_lang].upcoming_deal}
                                      </a>
                                      :
                                      <a
                                        style={{ backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                        data-id={this.state.topDeal.dealID}
                                        className="view-button btn btn-danger"
                                      >
                                        {languageConfig[this.state.default_lang].upcoming_deal}
                                      </a>
                                    }
                                  </div>
                                ) : (
                                  <div className="add-cart">
                                    {this.state.error ? (
                                      <div className="col-lg-12">
                                        <Notification type="danger">
                                          <span>
                                            <strong>Error:</strong> {this.state.error}
                                          </span>
                                        </Notification>
                                      </div>
                                    ) : null}
                                    {this.state.topDeal.proposal_type == 6 ? (
                                      <React.Fragment>
                                        {(isIE == false && isEdge == false && isMobile) ?
                                          <a
                                            className="view-button btn btn-deal"
                                            style={{ backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                            data-id={this.state.topDeal.dealID}
                                            onMouseEnter={this.hoverOn}
                                            onMouseLeave={this.hoverOff}
                                            onClick={
                                              this.state.topDeal.offerPrice > 0
                                                ? this.addToCart
                                                : this.generateCoupon.bind(
                                                  this,
                                                  this.state.topDeal.dealID
                                                )
                                            }
                                          >
                                            {
                                              this.state.topDeal.offerPrice > 0
                                                ? languageConfig[this.state.default_lang].coupon
                                                : languageConfig[this.state.default_lang].free_coupan
                                            }
                                          </a>
                                          :
                                          <a
                                            className="view-button btn btn-deal"
                                            style={{ backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                            data-id={this.state.topDeal.dealID}
                                            onClick={
                                              this.state.topDeal.offerPrice > 0
                                                ? this.addToCart
                                                : this.generateCoupon.bind(
                                                  this,
                                                  this.state.topDeal.dealID
                                                )
                                            }
                                          >
                                            {
                                              this.state.topDeal.offerPrice > 0
                                                ? languageConfig[this.state.default_lang].coupon
                                                : languageConfig[this.state.default_lang].free_coupan
                                            }
                                          </a>
                                        }
                                      </React.Fragment>
                                    ) : this.state.topDeal.proposal_type == 7 ? (
                                      <React.Fragment>
                                        {(isIE == false && isEdge == false && isMobile) ?
                                          <a
                                            onClick={() => this.affiliateSetting(this.state.topDeal)}
                                            className="view-button btn btn-deal"
                                            style={{ backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                            data-id={this.state.topDeal.dealID}
                                            onMouseEnter={this.hoverOn}
                                            onMouseLeave={this.hoverOff}
                                          >
                                            {languageConfig[this.state.default_lang].access}
                                          </a>
                                          :
                                          <a
                                            onClick={() => this.affiliateSetting(this.state.topDeal)}
                                            className="view-button btn btn-deal"
                                            style={{ backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                            data-id={this.state.topDeal.dealID}
                                          >
                                            {languageConfig[this.state.default_lang].access}
                                          </a>
                                        }
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment>
                                        {(isIE == false && isEdge == false && isMobile) ?
                                          (this.state.topDeal.proposal_type != 11) ?
                                            <Link
                                              to={`/auction-detail/${this.state.topDeal.dealID
                                                }`}
                                              replace
                                              className="view-button btn btn-deal"
                                              onClick={this.state.ClickToSelect ? this.ShowAttribute : this.addToCart}
                                              style={{ backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                              data-id={this.state.topDeal.dealID}
                                              onMouseEnter={this.hoverOn}
                                              onMouseLeave={this.hoverOff}
                                            >
                                              {this.state.ClickToSelect ? languageConfig[this.state.default_lang].click_to_select : languageConfig[this.state.default_lang].add_to_cart}
                                            </Link>
                                            :
                                            (this.state.ClickToSelect && this.state.topDeal.proposal_type == 11) ?
                                              <Button bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.ShowAttribute}><i className="glyphicon glyphicon-education" aria-hidden="true"></i> {languageConfig[this.state.default_lang].place_auction_bid}</Button>
                                              :
                                              <Button bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.handleModel}><i className="glyphicon glyphicon-education" aria-hidden="true"></i> {languageConfig[this.state.default_lang].place_auction_bid}</Button>
                                          :
                                          (this.state.topDeal.proposal_type != 11) ?
                                            <Link
                                              to={`/auction-detail/${this.state.topDeal.dealID
                                                }`}
                                              replace
                                              className="view-button btn btn-deal"
                                              onClick={this.state.ClickToSelect ? this.ShowAttribute : this.addToCart}
                                              style={{ backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                                              data-id={this.state.topDeal.dealID}
                                            >
                                              {this.state.ClickToSelect ? languageConfig[this.state.default_lang].click_to_select : languageConfig[this.state.default_lang].add_to_cart}
                                            </Link>
                                            :
                                            (this.state.ClickToSelect && this.state.topDeal.proposal_type == 11) ?
                                              <Button bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.ShowAttribute}><i className="glyphicon glyphicon-education" aria-hidden="true"></i> {languageConfig[this.state.default_lang].place_auction_bid}</Button>
                                              :
                                              <Button bsStyle="
                                    " style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.handleModel}><i className="glyphicon glyphicon-education" aria-hidden="true"></i> {languageConfig[this.state.default_lang].place_auction_bid}</Button>
                                        }
                                      </React.Fragment>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </React.Fragment>
                        }
                      </div>
                      {!isEmpty(this.state.topDeal.buyNowOption) && this.state.topDeal.proposal_type == 11 && this.state.topDeal.sold_out == false ? (

                        <div className="text-center">
                          <hr />
                          <h4 className="value">
                            Want to buy this now?
                          </h4>
                          <Link
                            to={`/auction-detail/${this.state.topDeal.dealID
                              }`}
                            replace
                            className="btn btn-success"
                            onClick={this.state.ClickToSelect ? this.ShowAttribute : this.addToCart}
                            style={{ backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                            data-id={this.state.topDeal.dealID}
                            onMouseEnter={this.hoverOn}
                            onMouseLeave={this.hoverOff}
                          >
                            {this.state.ClickToSelect ? languageConfig[this.state.default_lang].click_to_select : languageConfig[this.state.default_lang].buy_auction_now}
                          </Link>
                          <hr />
                        </div>
                      ) : null}

                      <div className="social-icons margin-top">
                        <FacebookShareButton
                          className="facebook"
                          quote={languageConfig[this.state.default_lang].offer+': ' + ((this.state.topDeal.writeUp) ? this.stripTags(this.state.topDeal.writeUp) : ReactHtmlParser((this.state.topDeal.child_deals) ? this.state.topDeal.mainDealText : this.state.topDeal.dealText)) + '\n '+languageConfig[this.state.default_lang].only_merchant_label+': ' + this.state.topDeal.merchantName}
                          imageUrl={'https://d266oi3blg1w2v.cloudfront.net/deal/primary15806363322027257_ab3Aqm.png'}
                          url={`${this.state.siteDomain}/auction-detail/${this.state.topDeal.dealID}-${this.state.topDeal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}
                        >
                          <FacebookIcon size={25} round={false} />
                        </FacebookShareButton>

                        <TwitterShareButton className="twitter" quote={(this.state.topDeal.writeUp) ? this.stripTags(this.state.topDeal.writeUp) : ReactHtmlParser((this.state.topDeal.child_deals) ? this.state.topDeal.mainDealText : this.state.topDeal.dealText)} url={`${this.state.siteDomain}/auction-detail/${this.state.topDeal.dealID}-${this.state.topDeal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}>
                          <TwitterIcon size={25} round={false} />
                        </TwitterShareButton>
                      </div>
                      {(this.state.topDeal.displayTimer == 1 && timerOption == "yes") &&
                        <div className="text-center timer">
                          <p>{languageConfig[this.state.default_lang].time_remaining}</p>
                          <i className="glyphicon glyphicon-time" />{" "}
                          {this.state.topDeal.time_remaining}
                        </div>
                      }
                      {(this.state.topDeal.maxAsGift > 0 && this.state.topDeal.redeemedAtCall == '1' && this.state.topDeal.sold_out == false && now.isAfter(this.state.topDeal.startDateTime)) &&
                        <div className="text-center margin-top">
                          <Button bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.handleModel}><i className="glyphicon glyphicon-gift" aria-hidden="true"></i> {languageConfig[this.state.default_lang].give_as_gift}</Button>
                        </div>
                      }
                    </div>
                  </div>

                </Col>
              </Row>
              <Row>
                <Col lg={8} md={8} sm={6} xs={12} >
                  <Tabs
                    activeKey={this.state.activeTab}
                    onSelect={this.handleTabs}
                    id="controlled-tab-example"
                  >
                    <Tab eventKey={1} title={languageConfig[this.state.default_lang].details}>
                      {(this.state.topDeal.websiteUrl) &&
                        <div className="merchant-website-url">
                          <a href={this.state.topDeal.websiteUrl} target="_blank">{this.state.topDeal.websiteUrl}</a>
                        </div>
                      }
                      {(this.state.topDeal.facebookPage) &&
                        <div className="merchant-facebook-url">
                          <a href={this.state.topDeal.facebookPage} target="_blank">{this.state.topDeal.facebookPage}</a>
                        </div>
                      }
                      {this.state.topDeal.writeUp
                        ? ReactHtmlParser(this.state.topDeal.writeUp)
                        : ""}
                    </Tab>
                    <Tab eventKey={2} title={languageConfig[this.state.default_lang].fine_print}>
                      {this.state.topDeal.termsAndConditions
                        ? ReactHtmlParser(this.state.topDeal.termsAndConditions)
                        : ""}
                    </Tab>
                    {this.state.topDeal.auctionHideLocation == '0' ? (
                      <Tab eventKey={3} title={languageConfig[this.state.default_lang].locations}>
                        <Row>
                          {(this.state.topDeal.dealLocation) &&
                            this.state.topDeal.dealLocation.map((data, index) =>
                              <Col md={4} xs={12} key={data.dealLocationID}>
                                <Row>
                                  <Col md={2} xs={12}>
                                    <span className="text-danger text-center" style={{ fontSize: '35px' }}><i className="glyphicon glyphicon-map-marker"></i></span>
                                  </Col>
                                  <Col md={10} xs={12}>
                                    <span><b>{data.locationName}</b></span>
                                    <br /><span>{data.locAddress1}</span>
                                    {(data.locAddress2) &&
                                      <span><br />{data.locAddress2}</span>
                                    }
                                    <br /><span>{data.locCity}, {data.locState} {data.locZipCode}</span>
                                    <br /><span>{data.locCountry}</span>
                                    {(data.locPhone) &&
                                      <span><br />{data.locPhone}</span>
                                    }
                                  </Col>
                                </Row>
                              </Col>
                            )
                          }
                        </Row>
                        <Row>
                          <Col md={12} xs={12}>
                            <br />
                            {(this.props.mapkey) &&
                              <Map
                                google={this.props.google}
                                style={style}
                                initialCenter={{
                                  lat: (this.state.topDeal.dealLatLong && this.state.topDeal.dealLatLong[0]) ? this.state.topDeal.dealLatLong[0].locLatitude : '26.851310',
                                  lng: (this.state.topDeal.dealLatLong && this.state.topDeal.dealLatLong[0]) ? this.state.topDeal.dealLatLong[0].locLongitude : '-77.01',
                                }}
                                mapType={'map'} //satellite
                                zoom={(this.state.topDeal.dealLatLong && this.state.topDeal.dealLatLong[0]) ? 17 : 2}
                                key={((this.state.topDeal.dealLatLong && this.state.topDeal.dealLatLong[0]) ? this.state.topDeal.dealLatLong[0].locLatitude : '26.851310') + ' - ' + ((this.state.topDeal.dealLatLong && this.state.topDeal.dealLatLong[0]) ? this.state.topDeal.dealLatLong[0].locLongitude : '-77.01')}
                              >
                                {(this.state.topDeal.dealLatLong) &&
                                  this.state.topDeal.dealLatLong.map((data, key) =>
                                    <Marker key={Math.random() + key} position={{ lat: data.locLatitude, lng: data.locLongitude }} />
                                  )
                                }
                              </Map>
                            }
                          </Col>
                        </Row>
                      </Tab>) : ('')}
                    {this.state.topDeal.question_switch == 'enable' ? (
                      <Tab eventKey={4} title={languageConfig[this.state.default_lang].question}>
                        {isEmpty(localStorage.getItem("user")) ? (
                          <Row>
                            <Col md={12} xs={12} className="text-center">
                              {(this.state.default_lang == 'en') ?
                                <h3 className="timer">
                                  You must be <Link replace to="/login">logged in</Link> to
                                  ask your question
                                </h3>
                                :
                                <h3 className="timer">
                                  You must be <Link replace to="/login">logged in</Link> to
                                  ask your question
                                </h3>
                              }
                            </Col>
                          </Row>
                        ) : (
                          <Question dealID={this.state.topDeal.dealID} default_lang={this.state.default_lang} buttonColor={this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color ? this.state.button_color : '#77C84E'} />
                        )}
                      </Tab>) : ('')}
                    {this.state.topDeal.reviews_switch == 'enable' ? (
                      <Tab eventKey={5} title={languageConfig[this.state.default_lang].reviews}>
                        <div>
                          <ReviewList dealID={this.props.route.match.params.dealID} />
                          <hr />
                          {isEmpty(localStorage.getItem("user")) ? (
                            <Row>
                              <Col md={12} xs={12} className="text-center">
                                <h3 className="timer">
                                  You must be <Link replace to="/login">logged in</Link> to leave a review.
                                </h3>
                              </Col>
                            </Row>
                          ) : (
                            <Reviews dealID={this.state.topDeal.dealID} default_lang={this.state.default_lang} buttonColor={(this.state.button_color) ? this.state.button_color : '#77C84E'} />
                          )}
                        </div>
                      </Tab>) : ('')}
                  </Tabs>
                </Col>
                <Col lg={4} md={4} sm={6} xs={12} className="pl-0">
                  {((userLogin !== '') && userLogin != '' && this.state.topDeal.proposal_type == 11) ? (
                    <div className="bg-white bannerDealcontainer shadow">
                      <h3>{languageConfig[this.state.default_lang].bid_highlights}</h3>
                      <div className="highlights">
                        <ul>
                          <li key={Math.random()} style={{ fontFamily: this.state.fontFamilies ? this.state.fontFamilies : '' }}>
                            <h4>{languageConfig[this.state.default_lang].current_bid} : &nbsp;
                              {this.state.topDeal.proposal_type == 11 && !isEmpty(this.state.topDeal.currentUserBidAmt) ? (
                                <Currency amount={this.state.topDeal.currentUserBidAmt} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                              ) : (
                                '-'
                              )}
                            </h4>
                          </li>
                          <li key={Math.random()} style={{ fontFamily: this.state.fontFamilies ? this.state.fontFamilies : '' }}>
                            <h4>{languageConfig[this.state.default_lang].auction_current_bid} : &nbsp;
                              {this.state.topDeal.proposal_type == 11 && !isEmpty(this.state.topDeal.lastAuctionAmount) ? (
                                <Currency amount={this.state.topDeal.lastAuctionAmount} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                              ) : (
                                <Currency amount={this.state.topDeal.offerPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                              )}
                            </h4>
                          </li>
                          <li key={Math.random()} style={{ fontFamily: this.state.fontFamilies ? this.state.fontFamilies : '' }}>
                            <h4>{languageConfig[this.state.default_lang].status} : &nbsp;
                              {this.state.topDeal.proposal_type == 11 && !isEmpty(this.state.topDeal.lastAuctionAmount) && !isEmpty(this.state.topDeal.currentUserBidAmt) && this.state.topDeal.lastAuctionAmount == this.state.topDeal.currentUserBidAmt ? (
                                languageConfig[this.state.default_lang].auction_win_status
                              ) : (
                                languageConfig[this.state.default_lang].auction_win_status1
                              )}
                            </h4>
                          </li>
                        </ul>
                      </div>
                    </div>) : null}
                  {((this.state.topDealHighlights.first !== '' || this.state.topDealHighlights.second !== '' || this.state.topDealHighlights.third !== '' || this.state.topDealHighlights.fourth !== '') && this.state.topDealHighlights != '') ? (
                    <div className="bg-white bannerDealcontainer shadow">
                      <h3>{languageConfig[this.state.default_lang].deal_highlights}</h3>
                      <div className="highlights">
                        <ul>
                          {(this.state.topDealHighlights.first) &&
                            <li key={Math.random()}><i className="glyphicon glyphicon-check" style={{ color: this.state.button_color }}></i> {this.state.topDealHighlights.first}</li>
                          }
                          {(this.state.topDealHighlights.second) &&
                            <li key={Math.random()}><i className="glyphicon glyphicon-check" style={{ color: this.state.button_color }}></i> {this.state.topDealHighlights.second}</li>
                          }
                          {(this.state.topDealHighlights.third) &&
                            <li key={Math.random()}><i className="glyphicon glyphicon-check" style={{ color: this.state.button_color }}></i> {this.state.topDealHighlights.third}</li>
                          }
                          {(this.state.topDealHighlights.fourth) &&
                            <li key={Math.random()}><i className="glyphicon glyphicon-check" style={{ color: this.state.button_color }}></i> {this.state.topDealHighlights.fourth}</li>
                          }
                        </ul>
                      </div>
                    </div>) : null}
                  {(this.state.topDeal.showQuantityLeft && this.state.topDeal.showQuantityLeft == 'yes') ? (
                    <div className="bg-white bannerDealcontainer shadow">
                      <h3>{languageConfig[this.state.default_lang].qty_left}: {this.state.topDeal.quantity_remaining}</h3>
                    </div>) : null}
                  {(this.state.topDeal.showPurchasedCount && this.state.topDeal.showPurchasedCount == '1' && this.state.topDeal.proposal_type != '11') ? (
                    <div className="deal-purchased shadow">
                      <i className="glyphicon glyphicon-shopping-cart" style={{ color: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}></i>&nbsp; <h3 style={{ fontFamily: this.state.fontFamilies ? this.state.fontFamilies : '' }}> {this.state.topDeal.purchase_count_bid ? this.state.topDeal.purchase_count_bid : this.state.topDeal.purchase_count} {languageConfig[this.state.default_lang].deals_purchased_0} <span>{languageConfig[this.state.default_lang].deals_purchased_1}</span> </h3>
                    </div>
                  ) : null}
                  {(this.state.topDeal.showPurchasedCount && this.state.topDeal.showPurchasedCount == '1' && this.state.topDeal.proposal_type == '11') ? (
                    <div className="deal-purchased shadow">
                      <i className="glyphicon glyphicon-shopping-cart" style={{ color: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}></i>&nbsp; <h3 style={{ fontFamily: this.state.fontFamilies ? this.state.fontFamilies : '' }}> {this.state.topDeal.purchase_count_bid ? this.state.topDeal.purchase_count_bid : this.state.topDeal.purchase_count} {languageConfig[this.state.default_lang].auction_purchased_0} <span>{languageConfig[this.state.default_lang].auction_placed_1}</span> </h3>
                    </div>
                  ) : null}
                </Col>
              </Row>
            </div>
          ) : null}
        </div>

        <div className="container">
          {totalDeal > 1 ? (
            <h4 className="also-like">You May Also Like</h4>
          ) : ("")}
          <Row>{currentDeals}</Row>
          {isEmpty(currentDeals) && !isLoading ? (
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <Image src={(this.state.NoRecord ? this.state.NoRecord : noRecordFound)} responsive style={{ margin: 'auto' }} />
              </Col>
            </Row>
          ) : ('')}
          {this.state.total > totalDeal ? (
            <Row>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                onClick={this.pagination}
                className="text-center"
              >
                <a
                  style={{ backgroundColor: (this.state.hover && this.state.hoverID == 'Load More') ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}
                  data-id={'Load More'}
                  onMouseEnter={this.hoverOn}
                  onMouseLeave={this.hoverOff}
                  className="btn btn-deal"
                >
                  {(this.state.load_more == true) ?
                    <React.Fragment>
                      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> {languageConfig[this.state.default_lang].load_more_deals}
                    </React.Fragment>
                    :
                    languageConfig[this.state.default_lang].load_more_deals
                  }
                </a>
              </Col>
            </Row>
          ) : null}
        </div>
        <hr />
        <Modal id="place-bid" style={{ fontFamily: this.state.fontFamilies ? this.state.fontFamilies : '' }} show={this.state.modelShow} onHide={this.closeModel}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.topDeal.dealText}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <Row>
              <Col xs={12} md={12} className="text-center">
                <h2>Current bid: &nbsp;&nbsp;<span style={{ color: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}>
                  {this.state.topDeal.proposal_type == 11 && this.state.topDeal.lastAuctionAmount !== '' && this.state.topDeal.lastAuctionAmount !== null ? (
                    <Currency amount={this.state.topDeal.lastAuctionAmount} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                  ) : (
                    <Currency amount={this.state.topDeal.offerPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                  )}
                </span>
                </h2>
                {/*<FormGroup>
                  <ControlLabel>Really want to win? Try raising your higher bid.</ControlLabel>
                </FormGroup>*/}
              </Col>
            </Row>
            <Row>

              <Col xs={12} md={12}>
                <FormGroup>
                  <FormControl
                    type="number"
                    name="placeBidAmount"
                    value={this.state.value}
                    onChange={this.handleChange}
                    style={{ borderColor: this.state.placeBidAmountError }}
                  />
                  Your bid amount should be &nbsp;
                  {this.state.topDeal.proposal_type == 11 && !isEmpty(this.state.topDeal.lastAuctionAmount) && isEmpty(this.state.topDeal.bidIncrements) ? (
                    <Currency amount={this.state.topDeal.lastAuctionAmount} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                  ) : (this.state.topDeal.proposal_type == 11 && !isEmpty(this.state.topDeal.lastAuctionAmount) && !isEmpty(this.state.topDeal.bidIncrements)) ? (
                    <Currency amount={(parseFloat(this.state.topDeal.lastAuctionAmount) + parseFloat(this.state.topDeal.bidIncrements)).toFixed(2)} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                  ) : (
                    <Currency amount={this.state.topDeal.offerPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                  )} or more
                </FormGroup>
                {this.state.placeBidAmountMinError ? (
                  <ControlLabel> <span className="text-danger">{this.state.placeBidAmountMinError}</span></ControlLabel>
                ) : null}
              </Col>
              <Col xs={12} md={4}></Col>
            </Row>
            <Row className="margin-top">
              <Col xs={12} md={12}>
                <Button bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} onClick={this.submitAsGift}>{languageConfig[this.state.default_lang].place_auction_bid} </Button>
              </Col>
            </Row>
          </Modal.Body>
          {/*<Modal.Footer>
            
            <Button onClick={this.closeModel}>{languageConfig[this.state.default_lang].close}</Button>
          </Modal.Footer>*/}
        </Modal>

        <Modal id="Select-Attribute" style={{ fontFamily: this.state.fontFamilies ? this.state.fontFamilies : '' }} show={this.state.attributeShow} onHide={this.attributeclose}>
          <Modal.Header closeButton>
            <Modal.Title>{languageConfig[this.state.default_lang].SelectAtrribute}</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.checkoutAttribute}>
            <Modal.Body>

              {this.state.topDeal && !isEmpty(this.state.topDeal.child_deals) && this.state.topDeal.child_deals.map((deal, index) => (
                (now.isAfter(deal.startDateTime) && now.isBefore(deal.expiryDateTime) && (this.state.dealID.indexOf(deal.dealID) > -1)) && (
                  <Row className="text-center">
                    <Col md={12} xs={12}>
                      <Row>
                        <Col componentClass={ControlLabel} sm={12}>
                          Current bid: &nbsp;&nbsp;
                          {deal.proposal_type == 11 && deal.lastAuctionAmount !== '' && deal.lastAuctionAmount !== null ? (
                            <Currency
                              amount={deal.lastAuctionAmount}
                              default_lang={this.state.default_lang}
                              moretext={deal.dealText}
                              default_currency={this.state.currency}
                            />
                          ) : (
                            <Currency
                              amount={deal.offerPrice}
                              default_lang={this.state.default_lang}
                              moretext={deal.dealText}
                              default_currency={this.state.currency}
                            />
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={12}>
                          Your bid amount should be &nbsp;
                          <h2 style={{ color: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}>{deal.proposal_type == 11 && !isEmpty(deal.lastAuctionAmount) && isEmpty(deal.bidIncrements) ? (
                            <Currency amount={deal.lastAuctionAmount} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                          ) : (deal.proposal_type == 11 && !isEmpty(deal.lastAuctionAmount) && !isEmpty(deal.bidIncrements)) ? (
                            <Currency amount={parseFloat(deal.lastAuctionAmount) + parseFloat(deal.bidIncrements)} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                          ) : (
                            <Currency amount={deal.offerPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                          )}</h2>  or more
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={12}>
                          <FormGroup controlId={Math.random()} key={Math.random()}>
                            {/*<ControlLabel>Really want to win? Try raising your higher bid.</ControlLabel>*/}
                            <FormControl
                              type="number"
                              name="placeBidAmount"
                              value={this.state.placeBidAmount}
                              onChange={this.handleChange}
                              style={{ borderColor: this.state.placeBidAmountError }}
                            />
                          </FormGroup>
                          {this.state.placeBidAmountMinError ? (
                            <ControlLabel> <span className="text-danger">{this.state.placeBidAmountMinError}</span></ControlLabel>
                          ) : null}
                        </Col>
                      </Row>
                      <Row className="margin-top">
                        <Col componentClass={ControlLabel} sm={12}>
                          {languageConfig[this.state.default_lang].SelectAtrribute}
                        </Col>
                      </Row>
                      {deal.attributes && JSON.parse(deal.attributes).length > 0 && JSON.parse(deal.attributes).map((attr, attridx) => (
                        <FormGroup controlId={Math.random()} key={Math.random()}>
                          <Row>
                            <Col componentClass={ControlLabel} sm={2}>
                              {attr.name}
                            </Col>
                            <Col sm={12}>
                              <FormControl
                                componentClass="select"
                                data-name={deal.dealID}
                                data-id={attridx}
                                data-value={attr.name}
                                onChange={this.handleAttribute.bind(this)}
                                key={Math.random()}
                                required={true}
                                defaultValue={this.state.attribute[deal.dealID] && this.state.attribute[deal.dealID][attridx] && this.state.attribute[deal.dealID][attridx]['"' + attr.name + '"'] ? this.state.attribute[deal.dealID][attridx]['"' + attr.name + '"'] : ''}
                              >
                                <option> Select </option>
                                {attr.dataValue && attr.dataValue.map((attrval, attridex) => (
                                  attr.type == 'date' ?
                                    <option
                                      value={
                                        moment(attrval.startDateTime).format("YYYY-MM-DD HH:mm") + ' to ' + moment(attrval.endDateTime).format("YYYY-MM-DD HH:mm")
                                      }
                                    >
                                      {
                                        moment(attrval.startDateTime).format("YYYY-MM-DD HH:mm") + ' to ' + moment(attrval.endDateTime).format("YYYY-MM-DD HH:mm")
                                      }
                                    </option>
                                    :
                                    <option
                                      value={attrval}
                                    >
                                      {attrval}
                                    </option>

                                ))}

                              </FormControl>
                            </Col>
                          </Row>
                        </FormGroup>
                      ))}
                      <Col>
                        {(this.state.errorattribute && !isEmpty(this.state.errorattribute[deal.dealID])) &&
                          <Col style={{ color: 'red' }}>
                            {this.state.errorattribute[deal.dealID]}
                          </Col>
                        }
                      </Col>
                    </Col>
                  </Row>
                )
              ))}
              {this.state.topDeal && isEmpty(this.state.topDeal.child_deals) &&
                <Row className="text-center">
                  <Col md={12} xs={12}>
                    <Row>
                      <Col componentClass={ControlLabel} sm={12}>
                        Current bid: &nbsp;&nbsp;
                        {this.state.topDeal.proposal_type == 11 && this.state.topDeal.lastAuctionAmount !== '' && this.state.topDeal.lastAuctionAmount !== null ? (
                          <Currency amount={this.state.topDeal.lastAuctionAmount} default_lang={this.state.default_lang} moretext={this.state.topDeal.dealText} default_currency={this.state.currency} />
                        ) : (
                          <Currency amount={this.state.topDeal.offerPrice} default_lang={this.state.default_lang} moretext={this.state.topDeal.dealText} default_currency={this.state.currency} />
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12}>
                        Your bid amount should be &nbsp;
                        <h2 style={{ color: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }}>{this.state.topDeal.proposal_type == 11 && !isEmpty(this.state.topDeal.lastAuctionAmount) && isEmpty(this.state.topDeal.bidIncrements) ? (
                          <Currency amount={this.state.topDeal.lastAuctionAmount} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                        ) : (this.state.topDeal.proposal_type == 11 && !isEmpty(this.state.topDeal.lastAuctionAmount) && !isEmpty(this.state.topDeal.bidIncrements)) ? (
                          <Currency amount={parseFloat(this.state.topDeal.lastAuctionAmount) + parseFloat(this.state.topDeal.bidIncrements)} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                        ) : (
                          <Currency amount={this.state.topDeal.offerPrice} default_lang={this.state.default_lang} className="price" default_currency={this.state.currency} />
                        )}</h2> or more
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12}>
                        <FormGroup>
                          {/*<ControlLabel>Really want to win? Try raising your higher bid.</ControlLabel>*/}
                          <FormControl
                            type="number"
                            name="placeBidAmount"
                            value={this.state.placeBidAmount}
                            onChange={this.handleChange}
                            style={{ borderColor: this.state.placeBidAmountError }}
                          />
                        </FormGroup>
                        {this.state.placeBidAmountMinError ? (
                          <ControlLabel> <span className="text-danger">{this.state.placeBidAmountMinError}</span></ControlLabel>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="margin-top">
                      <Col componentClass={ControlLabel} sm={12}>
                        {languageConfig[this.state.default_lang].SelectAtrribute}
                      </Col>
                    </Row>
                    {this.state.topDeal.attributes && JSON.parse(this.state.topDeal.attributes).length > 0 && JSON.parse(this.state.topDeal.attributes).map((attr, attridx) => (
                      <FormGroup controlId={Math.random()} key={Math.random()}>
                        <Row>
                          <Col componentClass={ControlLabel} sm={12}>
                            {attr.name}
                          </Col>
                          <Col sm={12}>
                            {attr.dataValue && !isEmpty(attr.dataValue) &&
                              <FormControl
                                componentClass="select"
                                data-name={this.state.topDeal.dealID}
                                data-id={attridx}
                                data-value={attr.name}
                                onChange={this.handleAttribute.bind(this)}
                                key={Math.random()}
                                required={true}
                                defaultValue={this.state.attribute[this.state.topDeal.dealID] && this.state.attribute[this.state.topDeal.dealID][attridx] && this.state.attribute[this.state.topDeal.dealID][attridx]['"' + attr.name + '"'] ? this.state.attribute[this.state.topDeal.dealID][attridx]['"' + attr.name + '"'] : ''}
                              >
                                <option>Select</option>
                                {attr.dataValue && attr.dataValue.map((attrval, attridex) => (
                                  attr.type == 'date' ?
                                    <option
                                      value={
                                        moment(attrval.startDateTime).format("YYYY-MM-DD HH:mm") + ' to ' + moment(attrval.endDateTime).format("YYYY-MM-DD HH:mm")
                                      }
                                    >
                                      {
                                        moment(attrval.startDateTime).format("YYYY-MM-DD HH:mm") + ' to ' + moment(attrval.endDateTime).format("YYYY-MM-DD HH:mm")
                                      }
                                    </option>
                                    :
                                    <option
                                      value={attrval}
                                    >
                                      {attrval}
                                    </option>

                                ))}

                              </FormControl>
                            }
                          </Col>
                        </Row>
                      </FormGroup>
                    ))}
                  </Col>
                </Row>
              }
              <Row className="text-center">
                <Col>
                  <Button className="margin-top" bsStyle="success" style={{ backgroundColor: this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color }} type="submit">{languageConfig[this.state.default_lang].place_auction_bid} </Button>
                </Col>
              </Row>
            </Modal.Body>
            {/*<Modal.Footer>
              
              <Button onClick={this.attributeclose}>{languageConfig[this.state.default_lang].close}</Button>
            </Modal.Footer>*/}
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

AuctionDetail.propTypes = {
  getDealList: PropTypes.func.isRequired,
  currentDealList: PropTypes.func.isRequired,
  dealDetail: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired,
  CheckUserKey: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  dealList: state.frontReducer.dealList,
  topDeal: state.frontReducer.detail,
  curDeal: state.frontReducer.curDeal,
  error: state.frontReducer.error,
  cartError: state.frontReducer.cartError,
  cartStatus: state.frontReducer.cartStatus,
  UserKeyError: state.frontReducer.UserKeyError,
  UserKeyStatus: state.frontReducer.UserKeyStatus,
  couponStatus: state.frontReducer.couponStatus,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default compose(
  GoogleApiWrapper((props) => ({
    apiKey: (props.mapkey) ? props.mapkey : '',
  }
  )),
  geolocated({
    positionOptions: {
      enableHighAccuracy: true
    },
    userDecisionTimeout: 5000
  }),
  connect(mapStateToProps, {
    getDealList,
    generateCoupon,
    renderAlert,
    clearAlert,
    currentDealList,
    dealDetail,
    addToCart,
    CheckUserKey
  })
)(AuctionDetail);


// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/AuctionDetail.js